@if (rendered$()) {
  <div [class]="bannerClass$()" [attr.role]="role$()">
    <div class="sol-banner-main">
      <sol-icon class="sol-banner-icon" [name]="icon$()" size="32" aria-hidden="true" />

      <div class="sol-banner-copy">
        @if (!heading$().isEmpty()) {
          <div class="sol-banner-title">{{ heading$() | translate }}</div>
        }
        @if (!description$().isEmpty()) {
          <div class="sol-banner-description">{{ description$() | translate }}</div>
        }
      </div>
    </div>

    @if (hasActions$() || dismissible$()) {
      <div class="sol-banner-actions">
        @if (action$(); as action) {
          <sol-button
            [type]="actionType$()"
            [text]="action.text | translate"
            [icon]="action.icon"
            [appendIcon]="action.appendIcon"
            [disabled]="action.disabled ?? false"
            [loading]="action.loading ?? false"
            [ariaLabel]="action.ariaLabel ?? action.text | translate"
            (click)="onActionPress(action)"
          />
        }
        @if (secondaryAction$(); as action) {
          <sol-button
            [type]="secondaryActionType$()"
            [text]="action.text | translate"
            [icon]="action.icon"
            [appendIcon]="action.appendIcon"
            [disabled]="action.disabled ?? false"
            [loading]="action.loading ?? false"
            [ariaLabel]="action.ariaLabel ?? action.text | translate"
            (click)="onSecondaryActionPress(action)"
          />
        }
        @if (dismissible$()) {
          <sol-button
            class="sol-banner-dismiss"
            [type]="SolButtonType.transparent"
            [icon]="SolIcon.remove"
            [ariaLabel]="'sol-common.close' | translate"
            (click)="onDismissPress()"
          />
        }
      </div>
    }

    <ng-content select="[slot=navigation]" />
  </div>
}
